import React from "react";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

export const TextFormField = ({ field, form, label, backgroundColor, isRequired, bgcolor, border, placeholder, ...props }) => {
	const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);

	// Handler for real-time input restriction
	const handleChange = (e) => {
		let value = e.target.value;

		// If type is "name", only allow letters and spaces
		if (props.type === "name") {
			value = value.replace(/[^a-zA-Z\s]/g, ""); // Remove numbers and special characters
		}

		form.setFieldValue(field.name, value);
	};

	return (
		<FormControl fullWidth error={!!errorText}>
			{label && (
				<InputLabel sx={{ ml: -1.6 }} shrink htmlFor={field.name}>
					<Typography variant="body1" sx={{ textTransform: "capitalize", color: "text.secondary" }}>
						{label}
						{isRequired && (
							<Typography variant="body1" color="error" component="span">
								{" *"}
							</Typography>
						)}
					</Typography>
				</InputLabel>
			)}
			<TextField
				{...field}
				fullWidth
				id={field.name}
				placeholder={placeholder}
				sx={{
					bgcolor: bgcolor,
					border: border || "0.5px solid #DC143C",
					borderRadius: "6px",
					mt: 2,
					"& fieldset": { border: "none" },
					"& .MuiInputBase-input": { padding: "10px 14px" }
				}}
				{...props}
				onChange={handleChange} // Restrict input while typing
				onBlur={(e) => {
					form.handleBlur(e);
				}}
			/>
			<Typography variant="body2" fontSize={"10px"} color="#DC143C" component="span">
				{errorText}
			</Typography>
		</FormControl>
	);
};
